// components/partnerOnboarding/personalInfo.js
import React, { useState, useEffect } from 'react';

function PersonalInfo() {
  const [hasDominicaDID, setHasDominicaDID] = useState(false);

  useEffect(() => {
    // Placeholder logic to check for Dominica DID NFT in the wallet
    // Replace this with actual logic to interact with the wallet and check for the NFT
    const checkDominicaDID = async () => {
      // Example: simulate an API call or wallet check
      const userHasDID = true; // Replace with real check
      setHasDominicaDID(userHasDID);
    };

    checkDominicaDID();
  }, []);

  return (
    <div>
      <h3 className="mb-4">Personal Information</h3>

      <div className="mb-3">
        {hasDominicaDID ? (
          <div className="alert alert-success" role="alert">
            <i className="fa fa-check-circle mx-2"></i>
            Your wallet contains the required Dominica Metaverse Bound Token (DMBT).
          </div>
        ) : (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-times-circle mx-2"></i>
            Your wallet does not contain the required Dominica Metaverse Bound Token (DMBT).
            <br />
            <small className="form-text text-muted">
              Please acquire your Dominica Metaverse Bound Token (DMBT) to become a partner.&nbsp;
              <a href="https://www.htx.com/support/84933699113560" target="_blank" rel="noopener noreferrer">Follow this guide</a> to get it.
            </small>
          </div>
        )}
      </div>

      <div className="mb-3">
        <input type="text" className="form-control" placeholder="Full Name" />
      </div>
      <div className="mb-3">
        <input type="email" className="form-control" placeholder="Email Address" />
      </div>
      <div className="mb-3">
        <input type="text" disabled className="form-control" placeholder="Wallet Address" />
        <small className="form-text text-muted">Your Tron wallet address to receive commissions.</small>
      </div>



      <div className="alert alert-info" role="alert">
        <i className='fa fa-lightbulb mx-2'></i>
        As a MintDeals Partner, you'll earn commissions for every new business or member you refer to our platform. It's easy to get started and there's no limit to how much you can earn!
      </div>
    </div>
  );
}

export default PersonalInfo;
